/**
 * Test if given argument is an object
 *
 * @param {any} item  The item to test
 * @returns {boolean} Wheter the given item is an object.
 */
export default function isObject(item: any): boolean {
	return item && typeof item === 'object' && !Array.isArray(item);
}
